import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import Date from '../components/Date';
import { Link } from 'gatsby';
import LinkArticle from '../components/LinkArticle';
import AngleRight from '../components/AngleRight';

import icbaGroupPhoto from '../images/news/icba-thinktech-group.jpg';
import nbcLogoBanner from '../images/news/nbc-logo-banner.png';
import rsiLogoBanner from '../images/news/rsi-logo-banner.png';
import icbaLogoBanner from '../images/news/icba-logo-banner.png';
import learnLogoBanner from '../images/news/learn-logo-banner.png';
import bankbeatLogoBanner from '../images/news/bankbeat-logo-banner.png';
import pymntsLogoBanner from '../images/news/pymnts-banner.png';
import venturecenterBanner from '../images/news/venturecenter-banner.png';
import ampBanner from '../images/news/amp-banner.png';
import theMoneyCloud from '../images/news/the-money-cloud-banner.png';
import sdVoyagerBanner from '../images/news/sd-voyager-banner.png';
import bankrateBanner from '../images/news/bankrate-banner.png';
import independentBanker from '../images/news/independent-banker.png';
import talkBusinessPolitics from '../images/news/talk-business-politics.png';
import businessPaymentsCoalition from '../images/news/businessPaymentsCoalition.png';
import nilson from '../images/news/nilson.png';
import americanbanker from '../images/news/americanbanker.png';
import cfotechoutlook from '../images/news/cfo-tech-outlook.png';
import eku from '../images/news/eku.png';
import mkBizRewardsCard from '../images/news/mk-business-rewards-card.png';

const Section = styled.section`
	color: #34495e;
	position: relative;
	z-index: 1;
	padding: 2em ${(props) => props.theme.paddingMobile};

	@media(${(props) => props.theme.mediumUp}) {
		padding: 2em ${(props) => props.theme.paddingMediumUp};
	}


	& .row-flush {
		justify-content: space-between;
	}

	& article {
		padding-left: 0;
		padding-right: 0;

		&:nth-child(odd) {
			@media(${(props) => props.theme.mediumUp}) {
				padding-right: 1em;
			}

			@media(${(props) => props.theme.largeUp}) {
				padding-right: 2em;
			}
		}

		&:nth-child(even) {
			@media(${(props) => props.theme.mediumUp}) {
				padding-left: 1em;
			}

			@media(${(props) => props.theme.largeUp}) {
				padding-left: 2em;
			}
		}
	}

	& figure {
		padding-left: 0;
		padding-right: 0;

		img {
			border-radius: 10px;
		}
	}

	& h2 {
		width: 100%;
		color: #303c47;
		line-height: 1.2;
		padding-top: 0;
		margin-top: 0;
		color: ${(props) => props.theme.lightBlue};

		&.blue {
			font-size: 21px;
		}
	}

	& hr {
		margin: 1.5em auto;
		width: 60%;
	}

	& p {
		font-weight: 600;
		line-height: 1.3;
	}

	& a {
		font-weight: 900;
		// color: #00a99d;
	}

	&.featured-stories article {
		margin-bottom: 4em;
	}

	&.featured-stories .row:last-child {
		margin-bottom: 0;
	}

`; // Section

const HeaderContent = styled.article`
	color: white;
	margin-top: 35px;

	& h1 {
		min-height: 0;
		margin-top: 1em;
	}

	@media(${(props) => props.theme.mediumUp}) {
		margin-top: 30px;
	}

	@media(${(props) => props.theme.largeUp}) {
		margin-top: 0px;
	}
`;

const PaddingRight30 = { paddingRight: '30px' };

const NewsroomPage = (props: any) => {
	const {
		data: {
			site: {
				siteMetadata: { endpoint },
			},
		},
	} = props;

	const newsroomHeaderContent = <HeaderContent>
		<h1>Newsroom Archive</h1>
		<p>Stay up on the latest news, featured<br />stories, and media from MK Decision.</p>
	</HeaderContent>;

	return <Layout
		pageTitle={'Newsroom Archive'}
		metaDescription={'Press Releases and MK Decision in the News'}
		splashHeaderMinHeight={'457px'}
		headerSplashBgPositionLarge='bottom right'
		headerContent={newsroomHeaderContent}
		headerSplashBgAverageColor={'#34414c'}
		CenteredSplashWrapperClass='newspaper'
	>
		<div className='centeredWrapper'>
			<Section className='news two-columns'>
				<h2 className='blue'>MK Happenings Archive</h2>
				<div className='row row-flush'>
					<LinkArticle
						internalLink={true}
						href={'/MK-Introduces-CCOS-Small-Business'}
						banner={mkBizRewardsCard}
						bannerAlt={'MK-Branded Business Rewards Card'}
						heading={'Introducing Small Business credit card applications'}
						date={'Feb 12, 2019'}
						paragraph={'MK today added small business cards applications as a component of their Credit Card Origination System (CCOS).'}
					/>
					<LinkArticle
						internalLink={true}
						href={'/ICBA-ThinkTECH-Accelerator'}
						banner={icbaGroupPhoto}
						bannerAlt={'ICBA Group Photo'}
						heading={'MK chosen as finalist for \nICBA ThinkTECH Accelerator'}
						headingStyle={PaddingRight30}
						date={'Jan 9, 2019'}
						paragraph={'MK accelerates expansion after being chosen for The Independent Community Bankers of America® (ICBA) and Venture Centers’ ICBA ThinkTECH Accelerator.'}
						readFullStory={true}
					/>
					<article className='col-12 col-md-6'>
						<p><a href='/newsroom/' className='animate-right'>View recent MK Happenings<AngleRight /></a></p>
					</article>
				</div>
			</Section>
			<Section className='featured-stories two-columns'>
				<h2 className='blue'>Featured Stories Archive</h2>
				<div className='row row-flush'>
					<LinkArticle
						href={'https://finance-technology.cfotechoutlook.com/cxoinsights/how-fintech-changes-the-game-for-community-banks-and-their-customers-nid-721.html'}
						banner={cfotechoutlook}
						bannerAlt={'featured on CFO Tech Outlook'}
						heading={'How Fintech Changes the Game for Community Banks and Their Customers'}
						date={'Nov 5, 2019'}
						paragraph={'Kevin Tweddle, COO of ICBA Services Network, talks about how MK Decision and ICBA ThinkTECH Accelerator alumni are working with community financial institutions to help them succeed in the digital age.'}
					/>
					<LinkArticle
						href={'https://finance.eku.edu/insidelook/banking-and-finance-meetup-feature-national-industry-experts'}
						banner={eku}
						bannerAlt={'featured on Eastern Kentucky Universtiy'}
						heading={'Banking and Finance Meetup to Feature National Industry Experts'}
						date={'Sep 25, 2019'}
						paragraph={'The afternoon of networking will showcase business majors with a special address from Kentucky Banking Commissioner Charles A. Vice as well as a presentation from Loughlin Cleary and Har Rai Khalsa, CEO of MK Decision.'}
					/>
					<LinkArticle
						href={'https://www.venturecenter.co/blog/2019/8/29/mk-decision-founder-qampa'}
						banner={venturecenterBanner}
						bannerAlt={'featured on The Venture Center'}
						heading={"ICBA ThinkTECH Accelerator interviews MK Decision's Co-Founder"}
						date={'Aug 29, 2019'}
						paragraph={'As The Venture Center prepares for the ICBA ThinkTECH Accelerator 2.0, we’re looking back at the men and women who made the first ThinkTECH Accelerator so successful. Har Rai Khalsa, CEO and Founder of MK Decision, is one of those entrepreneurs.'}
					/>
					<LinkArticle
						href={'https://nilsonreport.com/publication_newsletter_archive_issue.php?issue=1156'}
						banner={nilson}
						bannerAlt={'featured on The Nilson Report'}
						heading={'MK Decision among companies mentioned in The Nilson Report'}
						date={'Jun 1, 2019'}
						paragraph={'ICBA Bancard will use a loan origination system from MK Decision to streamline the online credit card application process for its issuing member banks. Those issuers collectively generated more than $28 billion in purchase volume in 2018.'}
					/>
					<LinkArticle
						href={'https://independentbanker.org/2019/06/what-do-fintechs-say-is-next-for-the-industry/'}
						banner={independentBanker}
						bannerAlt={'featured on Independent Banker'}
						heading={'What do fintechs say is next for the industry?'}
						date={'Jun 1, 2019'}
						paragraph={"Challenges for community banks and pointers to solutions, from Har Rai Khalsa of MK Decision and other CEOs of FinTech startups at the ICBA's ThinkTECH Accelerator program."}
					/>
					<LinkArticle
						href={'https://www.bankrate.com/mortgages/community-banks-add-technology-for-consumers/'}
						banner={bankrateBanner}
						bannerAlt={'featured on Bankrate'}
						heading={'Community banks step up tech to compete with big banks, benefiting consumers'}
						date={'May 31, 2019'}
						paragraph={'Companies like MK Decision can drastically speed up the loan process, allowing banks to make decisions in seconds when it used to take days.'}
					/>
					<LinkArticle
						href={'https://businesspaymentscoalition.org/wp-content/uploads/vf-meeting-05-21-19-recap.pdf'}
						banner={businessPaymentsCoalition}
						bannerAlt={'featured on BusinessPaymentsCoalition'}
						heading={'How Community Banks Partner with Fintechs (PDF)'}
						date={'May 21, 2019'}
						paragraph={'A PDF presentation from Business Payments Coalition.'}
					/>
					<LinkArticle
						href={'https://bankbeat.biz/bank-owners-encouraged-to-establish-tech-partnerships/'}
						banner={bankbeatLogoBanner}
						bannerAlt={'featured on BankBeat'}
						heading={'Bank owners encouraged to establish tech partnerships'}
						date={'May 7, 2019'}
						paragraph={"A panel discussion led by Kevin Tweddle of Independent Community Bankers of America, featuring Har Rai Khalsa, MK Decision's co-founder and CEO."}
					/>
					<LinkArticle
						href={'http://sdvoyager.com/interview/meet-har-rai-khalsa-mk-decision-233-st-1210-san-diego-ca-92101/'}
						banner={sdVoyagerBanner}
						bannerAlt={'featured'}
						heading={'Meet Har Rai Khalsa'}
						date={'May 9, 2019'}
						paragraph={"Interview with MK's co-founder and CEO, Har Rai Khalsa."}
					/>
					<LinkArticle
						href={'https://amppob.com/icba-thinktech-accelerator/'}
						banner={ampBanner}
						bannerAlt={'featured on Arkansas Money and Politics'}
						heading={'ICBA ThinkTECH Accelerator'}
						date={'Apr 5, 2019'}
						paragraph={'MK among 10 FinTech startups to complete to ICBA Venture Center boot camp.'}
					/>
					<LinkArticle
						href={'https://bankbeat.biz/online-lending-platform-focuses-on-community-banking/'}
						banner={bankbeatLogoBanner}
						bannerAlt={'featured on BankBeat'}
						heading={'Online lending platform focuses on community banking'}
						date={'Apr 4, 2019'}
						paragraph={'BankBeat interviews CEO of MK Decision, Har Rai Khalsa, on what solutions MK has to offer to community banks.'}
					/>
					<LinkArticle
						href={'https://www.venturecenter.co/blog/2019/4/1/demo-day-with-the-venture-center-celebrates-icba-thinktech-accelerator-finalists'}
						banner={venturecenterBanner}
						bannerAlt={'featured on Venture Center'}
						heading={'MK Decision a finalist at ICBA ThinkTECH Accelerator'}
						headingStyle={PaddingRight30}
						date={'Apr 1, 2019'}
						paragraph={'Demo Day with The Venture Center Celebrates ICBA ThinkTECH Accelerator Finalists.'}
					/>
					<LinkArticle
						href={'https://www.pymnts.com/loans/2019/online-credit-icba-bancard-mk-decision/'}
						banner={pymntsLogoBanner}
						bannerAlt={'featured on PYMNTS'}
						heading={'ICBA Bancard And MK Decision Team For Loan Approvals'}
						date={'Mar 28, 2019'}
						paragraph={'ICBA Bancard, the payments services subsidiary of the Independent Community Bankers of America (ICBA), announced a new partnership with MK Decision (MK) for its online loan-origination system.'}
					/>
					<LinkArticle
						href={'https://www.blog.themoneycloud.com/digital-currencies/icba-bancard-and-mk-decision-team-for-loan-approvals/'}
						banner={theMoneyCloud}
						bannerAlt={'featured on the money cloud'}
						heading={'ICBA Bancard And MK Decision Team For Loan Approvals'}
						date={'Mar 28, 2019'}
						paragraph={'ICBA Bancard, the payments services subsidiary of the Independent Community Bankers of America, announced a new partnership with MK Decision for its online loan-origination system.'}
					/>
					<LinkArticle
						href={'https://www.icba.org/news/press-releases/2019/03/18/icba-bancard-and-mk-decision-partner-to-offer-real-time-loan-approvals'}
						banner={icbaLogoBanner}
						bannerAlt={'featured on ICBA'}
						heading={'ICBA Bancard and MK Decision Partner to Offer Real-Time Loan Approvals'}
						date={'Mar 18, 2019'}
						paragraph={'NASHVILLE, TN - ICBA Bancard, the payments services subsidiary of the Independent Community Bankers of America® (ICBA), today announced a new partnership with MK Decision (MK) for its online loan-origination system.'}
					/>
					<LinkArticle
						href={'https://bankbeat.biz/bankers-bank-to-offer-new-credit-card-origination-service/'}
						banner={bankbeatLogoBanner}
						bannerAlt={'featured on BankBeat'}
						heading={'Bankers’ Bank to offer new credit card origination service'}
						date={'Mar 14, 2019'}
						paragraph={'Madison, Wis.-based Bankers’ Bank is collaborating with MK Decision to bring the firm’s Credit Card Origination System™ to over 100 community bank partners throughout the Midwest.'}
					/>
					<LinkArticle
						href={'https://www.icba.org/news/blog-details/main-street-matters---innovation/2019/02/13/streamlining-digital-lending-with-accelerator-finalist-mk-decision'}
						banner={icbaLogoBanner}
						bannerAlt={'featured on ICBA'}
						heading={'Streamlining Digital Lending with Accelerator Finalist MK Decision'}
						date={'Feb 13, 2019'}
						paragraph={"We're thrilled to be working with MK Decision and to have the opportunity to introduce it to the nation’s community banks. - Tina Giorgio, President and CEO of ICBA Bancard"}
					/>
					<LinkArticle
						href={'https://www.kark.com/news/local-news/10-startup-companies-selected-for-lr-boot-camp-program/1694813569'}
						banner={nbcLogoBanner}
						bannerAlt={'featured on News affliates'}
						heading={'10 Startup Companies Selected for Little Rock Boot Camp Program'}
						date={'Jan 9, 2019'}
						paragraph={'LITTLE ROCK, AR - Ten startup companies from across the world have been selected to participate in a rigorous 12-week boot camp program at the Venture Center.'}
					/>
					<LinkArticle
						href={'https://talkbusiness.net/2019/01/venture-center-icba-pick-10-startups-for-new-fintech-program-in-little-rock/'}
						banner={talkBusinessPolitics}
						bannerAlt={'featured on AR Talk Business and Politics'}
						heading={'Venture Center, ICBA pick 10 startups for new ‘fintech’ program in Little Rock'}
						date={'Jan 9, 2019'}
						paragraph={'Gov. Asa Hutchinson joined The Independent Community Bankers of America (ICBA)... to announce the selection of 10 startup firms from across the globe to participate in a new “fintech” accelerator program to help smaller banks.'}
					/>
					<LinkArticle
						href={'https://www.americanbanker.com/news/icba-selects-first-fintechs-for-new-accelerator-program'}
						banner={americanbanker}
						bannerAlt={'featured on AmerincanBanker'}
						heading={'ICBA selects first fintechs for new accelerator program'}
						date={'Jan 9, 2019'}
						paragraph={"American Banker shares ICBA's announcement of the 10 FinTech finalists that will participate in the first ThinkTECH Accelerator in Little Rock, Arkansas. "}
					/>
					<LinkArticle
						href={'https://blog.rsisecurity.com/client-feature-mk-decision-the-future-of-credit-based-decisioning/'}
						banner={rsiLogoBanner}
						bannerAlt={'featured on RSI blog'}
						heading={'MK Decision - The Future of Credit Based Decisioning'}
						headingStyle={PaddingRight30}
						date={'Sep 12, 2018'}
						paragraph={'As compliance and cybersecurity providers, RSI Security has the opportunity to work with forward thinking, innovative, and downright neat companies.'}
					/>
					<LinkArticle
						href={'https://www.learnacademy.org/blog/LEARN-alumni-are-helping-MK-Decision-rise-to-one-of-FinTech-top-startups'}
						banner={learnLogoBanner}
						bannerAlt={'featured on Learn Academy'}
						heading={"LEARN alumni are helping MK Decision rise to one of FinTech's top startups."}
						date={'Sep 5, 2018'}
						paragraph={"LEARN alumni have contributed to many development projects at MK Decision, most notably, the launch of MK's Credit Card Origination System (CCOS) in May of 2018."}
					/>
				</div>
				<p><a href='/newsroom/' className='animate-right'>View recent Featrued Stories<AngleRight /></a></p>
			</Section>
		</div>
	</Layout>;
};

export default NewsroomPage;

export const pageQuery = graphql`
	query {

		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;
